import { render, staticRenderFns } from "./AddNewVegeIssue.vue?vue&type=template&id=26fd0716&scoped=true"
import script from "./AddNewVegeIssue.vue?vue&type=script&lang=ts"
export * from "./AddNewVegeIssue.vue?vue&type=script&lang=ts"
import style0 from "./AddNewVegeIssue.vue?vue&type=style&index=0&id=26fd0716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd0716",
  null
  
)

export default component.exports